import { useEstimationsDialog } from './EstimationsDialog.h'

import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import LinearProgress from '@mui/material/LinearProgress'
import MotionDialog from '@shared/components/MotionDialog'

import { InfiniteList } from '@shared/components/InfiniteList'
import EstimationItem from '@shared/components/estimations/Item'

export default function EstimationsDialog() {
    const {
        handleClose,
        manager
    } = useEstimationsDialog()

    return (
        <MotionDialog
            onClose={handleClose}
            slotProps={{
                paper: {
                    sx: {height: '100%'}
                }
            }}
        >
            <DialogTitle>المقايسات</DialogTitle>
            <DialogContent sx={{p: 0}}>
                {manager.isLoading && <LinearProgress />}
                {manager.error && 
                    <Typography className='centerized'>حدث خطأ</Typography>
                }
                <InfiniteList manager={manager}>
                    {manager.visibleItems.map(({item, options}) =>
                        <EstimationItem
                            key={item.id}
                            item={item}
                            options={options}
                        />
                    )}
                </InfiniteList>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='text'
                    onClick={handleClose}
                >إغلاق</Button>
            </DialogActions>
        </MotionDialog>
    )
}